// extracted by mini-css-extract-plugin
export default {"wrap":"EmptyBonusList_wrap--eUh","icon":"EmptyBonusList_icon--qVh","text":"EmptyBonusList_text--UFs"};